/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Export_Created_AtInputs */

const en_manual_qc_export_created_at = /** @type {(inputs: Manual_Qc_Export_Created_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created At`)
};

const fr_manual_qc_export_created_at = /** @type {(inputs: Manual_Qc_Export_Created_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cree le`)
};

const de_manual_qc_export_created_at = /** @type {(inputs: Manual_Qc_Export_Created_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellt am`)
};

const it_manual_qc_export_created_at = /** @type {(inputs: Manual_Qc_Export_Created_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creato a`)
};

const ru_manual_qc_export_created_at = /** @type {(inputs: Manual_Qc_Export_Created_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создано в`)
};

const es_manual_qc_export_created_at = /** @type {(inputs: Manual_Qc_Export_Created_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creado en`)
};

const zh_cn2_manual_qc_export_created_at = /** @type {(inputs: Manual_Qc_Export_Created_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建于`)
};

const ja_manual_qc_export_created_at = /** @type {(inputs: Manual_Qc_Export_Created_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作成日`)
};

const hi_manual_qc_export_created_at = /** @type {(inputs: Manual_Qc_Export_Created_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पर निर्मित`)
};

const pt_pt2_manual_qc_export_created_at = /** @type {(inputs: Manual_Qc_Export_Created_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criado em`)
};

/**
* | output |
* | --- |
* | "Created At" |
*
* @param {Manual_Qc_Export_Created_AtInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_export_created_at = /** @type {((inputs?: Manual_Qc_Export_Created_AtInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Export_Created_AtInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_export_created_at(inputs)
	if (locale === "de") return de_manual_qc_export_created_at(inputs)
	if (locale === "it") return it_manual_qc_export_created_at(inputs)
	if (locale === "ru") return ru_manual_qc_export_created_at(inputs)
	if (locale === "es") return es_manual_qc_export_created_at(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_export_created_at(inputs)
	if (locale === "ja") return ja_manual_qc_export_created_at(inputs)
	if (locale === "hi") return hi_manual_qc_export_created_at(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_export_created_at(inputs)
	return en_manual_qc_export_created_at(inputs)
});